import Icon from './Icon.vue';
import Htag from './Htag.vue';
import Search from './Search/Search.vue';
import sAvatar from './Avatar.vue';
import AvatarLine from './AvatarLine.vue';
import Spinner from './Spinner.vue';
import Status from './Status.vue';

import VueECharts from 'vue-echarts';

const components = [
    { name: 'Icon', component: Icon },
    { name: 'Htag', component: Htag },
    { name: 'Search', component: Search },
    { name: 'Spinner', component: Spinner },
    { name: 'VueECharts', component: VueECharts },
    { name: 'Status', component: Status },
    { name: 'AvatarLine', component: AvatarLine },

    { name: 'sAvatar', component: sAvatar },
];

export default {
    install(app) {
        components.forEach(({ name, component }) => {
            app.component(name, component);
        });
    },
};
